@if (showHideFooter) {
  <div class="footer text-base text-vis-subtle">
    <div class="flex flex-wrap container !px-v-spacing">
      <!-- Logo + Aceable Family -->
      <div class="footer__logo-container md:border-0 w-full lg:w-1/2 pb-v-spacing lg:pb-0 flex flex-col md:flex-col justify-start md:justify-between lg:justify-start align-top">
        @for (footerLogo of footerLogos; track footerLogo) {
          <a
            class="hover:text-ace-teal-500"
            [href]="footerLogo.logoLink"
            aria-labelledby="logo-hospitality-footer"
            >
            @if (footerLogo.logoImage.length > 0) {
              <img
                class="footer-logo h-[44px] w-auto"
                width="171"
                height="44"
                [src]="footerLogo.logoImage[0].url"
                [alt]="footerLogo.logoImage[0].altText ? footerLogo.logoImage[0].altText : ''"
                />
            }
            {{ footerLogo.logoImage.length === 0 ? stripLink(footerLogo.logoLink) : '' }}
            <span class="sr-only" id="logo-hospitality-footer">Hospitality Navigation Link</span>
          </a>
        }
        <!-- Aceable Family -->
        <div class="font-extrabold mt-6 mb-1 text-sm">
          <p>Part of the
            <a [attr.aria-labelledby]="accessibilityService.getAriaLabelledby('Aceable') + '-nav-label'" class="text-vis-brand-1 underline font-bold" href="https://www.aceable.com">
              <span>Aceable</span>
              <!-- Hidden Context -->
              <span [attr.id]="accessibilityService.getAriaLabelledby('Aceable') + '-nav-label'" class="sr-only">{{accessibilityService.getCompleteTextContextForButton('/Aceable/')}}</span>
            </a>
          Family</p>
        </div>
        <!-- Vertical Links: Driving, Real Estate -->
        <div class="font-bold text-vis-brand-1 text-sm pb-v-spacing lg:pb-0">
          @for (link of verticalLinks; track link; let last = $last) {
            <a [attr.aria-labelledby]="accessibilityService.getAriaLabelledby(link.linkText) + '-nav-label'" [href]="link.linkUrl" class="text-vis-brand-1 underline">
              <span>{{ link.linkText }}</span>
              <!-- Hidden Context -->
              <span [attr.id]="accessibilityService.getAriaLabelledby(link.linkText) + '-nav-label'" class="sr-only">{{accessibilityService.getCompleteTextContextForButton(link.linkUrl, link.linkText)}}</span>
            </a>
            @if (!last) {
              <span class="mx-[10px] text-vis-subtle">|</span>
            }
          }
        </div>
        <!-- Refer and Partner Buttons -->
        @if (shareButtons) {
          <div class="flex flex-row mb-6 sm:mb-2 mt-6 w-full">
            @for (b of shareButtons; track itemLabel($index, b); let last = $last) {
              <a
            class="
              footer-button
              text-ace-teal-800
              hover:text-vis-reverse
              active:text-vis-reverse
              inline-flex
              cursor-pointer
              items-center
              justify-center
              py-3.5
              px-6
              w-full
              xs:w-fit
              border-[1.5px]
              border-solid
              border-ace-teal-800
              hover:bg-ace-teal-800
              active:border-ace-teal-700
              active:bg-ace-teal-700
              rounded-[100px]
              {{ !last ? 'mr-2' : '' }}"
                href="{{b.link}}"
                [attr.aria-labelledby]="accessibilityService.getAriaLabelledby(b.label) + '-nav-label'"
                >
                <span class="label-primary" [innerHTML]="b.label"></span>
                <!-- Hidden Context -->
                <span [attr.id]="accessibilityService.getAriaLabelledby(b.label) + '-nav-label'" class="sr-only">{{accessibilityService.getCompleteTextContextForButton(b.link, b.label)}}</span>
              </a>
            }
          </div>
        }
        <div class="border-b-[1px] border-[#B7BEC1] lg:border-0"></div>
      </div>
      <!-- General Links: Careers, Partnerships, Help Center, Contact, Our Blog -->
      <footer-link
        class="md:mt-1 pt-v-spacing lg:pl-v-spacing lg:pt-0 lg:mt-0 w-1/2 lg:w-1/4 flex lg:justify-center"
        [links]="generalLinks"
        footerLocation="general"
        alignClass=""
        linkClass="w-full lg:w-full"
      ></footer-link>
      <!-- Social Links: Twitter, Facebook, Instagram, LinkedIn, YouTube -->
      <footer-link
      class="
        md:pl-0
        lg:mt-0
        md:w-1/2
        mx-0
        pt-v-spacing
        md:mt-1
        lg:py-0 lg:w-1/4
        py-3
        lg:pl-v-spacing
        flex
      "
        [links]="socialLinks"
        footerLocation="social"
        alignClass="lg:items-start w-full sm:w-3/4 md:w-full"
        linkClass=""
      ></footer-link>
      <!-- Copyright -->
      <div class="pt-v-spacing text-sm self-end lg:text-left footer__copyright py-1 w-full">
        <!-- Bottom Links: Privacy Policy, Terms & Conditions -->
        <div class="w-full flex flex-wrap flex-row items-baseline">
          <footer-link
            footerLocation="bottom"
            [links]="bottomLinks"
            alignClass="w-full"
            >
          </footer-link>
          <span class="mx-[10px]">|</span>
          <button (click)="openPrivacyManagerModal()">Do Not Sell or Share My Personal Information</button>
        </div>
        <p class="pt-3 lg:pt-2">© {{ copyrightYear }} Aceable, Inc. <br class="hidden block sm:hidden">All rights reserved.</p>
      </div>
    </div>
  </div>
}
@if (emailCaptureData && !(promoBannerActive && ((!!graphicBanner) && displayRE))) {
  <email-capture [data]="emailCaptureData"></email-capture>
}

@if (showPrivacyManagerModal) {
  <privacy-manager (hideModal)="showPrivacyManagerModal = false;"></privacy-manager>
}
